import React from 'react'
import SideLogo from '../../Images/TopbarImg/Logo.png'
import Aos from 'aos'

const Joinings = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='aboutus-body'>
                    <div className='aboutus-left' data-aos='fade-right'>
                        <img src={SideLogo} alt='Kanaklaxmi-Logo' />
                    </div>
                    <div className='aboutus-right' data-aos='fade-right'>
                        <div className='aboutus-body-1'>
                            <div className='aboutus-body-title'>
                                <h1>आवद्धता</h1>
                            </div>
                            <div className='aboutus-body-content'>
                                <p>
                                    <ul>
                                        <li>नेपाल बचत तथा ऋण केन्द्रीय सहकारी संघ लि. ( नेफ्स्कून)</li>
                                        <li>जिल्ला बचत तथा ऋण सहकारी संघ लि., मोरङ</li>
                                        <li>जिल्ला सहकारी संघ लि.मोरङ</li>
                                        <li>राष्ट्रिय सहकारी बैक लि.</li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Joinings